<!-- 新增收货地址页 -->
<template>
  <div class="loginAdd">
    <div class="wrapAdd1">
      <div class="inputFormAdd">
        <div class="telDivAdd addflex">
          <span>姓名：</span>
          <input class="pswWidth" type="text" placeholder="请输入姓名" v-model="user.consignee" />
        </div>

        <div class="telDivAdd addflex">
          <span>联系电话：</span>
          <input class="pswWidth" type="text" placeholder="请输入电话" v-model="user.mobile"/>
        </div>

        <div class="telDivAdd telDivAdd_diqu">
          <span>所在地区：</span>
          <!-- style="width:70% ;text-align: left; font-size:14px"  -->
          <li class="selbtn" ref="city" @click="pickerVisible = true">选择地区</li>
          <van-popup v-model="pickerVisible" round position="bottom">
            <van-picker
              value-key="label"
              show-toolbar
              :columns="pickData"
              @cancel="pickerVisible = false"
              @confirm="onConfirm"
              @change="onChange"
            />
          </van-popup>
          <!-- <VuePicker
            :data="pickData"
            :showToolbar="true"
            @change="changes"
            @cancel="cancel"
            @confirm="confirm"
            :visible.sync="pickerVisible"
          /> -->
        </div>
        <div class="telDivAdd telDivAdd_fool">
          <span>详细地址：</span>
          <textarea rows="10" cols="30" v-model="user.address" placeholder="街道信息、楼牌号等"></textarea>
        </div>
      </div>
      <div class="loginBtn" @click="save" :style="{background: `${colourName}`}">{{ addId ? '确认修改' : '保存地址' }}</div>
    </div>
    <div class="moren_address"> <input type="checkbox" v-model="ischecked"> 设为默认 </div>
  </div>
</template>

<script>
import * as api from "@/api";
import { mapMutations } from "vuex";
import JmmToast from '@/components/JmmToast'
import VuePicker from "vue-pickers";
import { Popup,Picker } from 'vant';
// import cityData from "../../utils/CityData.js"
let realnameRegular = /^[\u0391-\uFFE5]+$/;
const deepFreeze = function(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    propNames.forEach(function(name) {
      var prop = obj[name];
      if (typeof prop == 'object' && prop !== null) {
        deepFreeze(prop);
      }
    })
    return Object.freeze(obj)
  }
  // 冻结以提升性能
  // const freezeCityData = deepFreeze(cityData)
export default {
  name: "login",
  data() {
    return {
      colourName: '#fb4e4d',
      token: "jjcimpilpgejfeehkdinjlbgabbgchhe",
      sign: "",
      showToolbar: true,
      pickerVisible: false,
      pickData: [],
      cityArr:[],//当前选择的城市 用于判断地址滑动的第几列
      // pickData: freezeCityData,
      addId: null,          // 修改时传来的ID
      return_url: '',          // 跳转新增页面传递的 地址参数，判断是不是空的
      formList: '',          // 跳转新增页面传递的 地址参数，判断是不是空的
      userId: null,          // 本地存储的 用户id
      user: {                  // 用户信息
        consignee: '',        //收货人名称
        mobile: '',      
        address: '',
        town: '',              // 街道
        district: '',          //区
        city: '',              // 市
        province: '',         // 省
      },          
      ischecked: false
    };
  },
  components: {
    VuePicker,
    [Popup.name]:Popup,
    [Picker.name]:Picker
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    // 色调选择
    this.displayType = localStorage.getItem("displayType");
    if(this.displayType === '0'){
      this.colourName = "#f8992d";
    }
    this.sign = this.$route.query.sign;
    if(null == this.sign || undefined == this.sign){
      this.sign = '';
    }
    if('' == this.sign){
      this.sign = localStorage.getItem('codeSign');
    }else{
      localStorage.setItem('codeSign', this.sign);
    }

    this.addId = this.$route.query.addId;
    this.return_url = this.$route.query.return_url
    this.formList = localStorage.getItem('addressUrl')
    this.getAddressList();
    // this.getBanben()   // 进入页面先判断版本号

    // let isList = JSON.parse(localStorage.getItem('addList'))
    
    //  isList == null ? this.getByRedis() : this.pickData = deepFreeze(isList)
    //  isList ? this.pickData = deepFreeze(isList) : this.getByRedis()
    //  console.log(isList, '查看有没有返回数据')
  },
  mounted () {
    if (this.addId) {
       document.title = this.addId ? '修改收货地址' : '新增收货地址'
       this.Toshow()
    }
  },
  computed: {
    styleVar() {
      return {
        '--colourName': this.colourName
      }
    }
  },
  methods: {

    // 查看地址库版本号，以及同时调用四级联动数据，保存本地
    getBanben: async function() {
       const res = await api.user.getVersionAddress()
       if (res.code == '000000') {
        res.data.version == 1 ? this.pickData = deepFreeze(JSON.parse(localStorage.getItem('addList'))) : this.getByRedis()   
       }
    },
    getByRedis: async function() {
      let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj'
       localStorage.setItem("reToken", testToken);
       const res = await api.user.getAddressByRedis()
       if (res.code == '000000') {
         this.pickData = deepFreeze(res.data)
         localStorage.setItem('addList', JSON.stringify(res.data))
       } else {
         JmmToast(res.message)
       }
    },
    getAddressList: async function() {
      let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj'
       localStorage.setItem("reToken", testToken);
       const res1 = await api.user.getAddressList(100000)
       if (res1.code == '000000') {
         this.pickData[0] = {
           values: res1.data
         };
         const res2 = await api.user.getAddressList(res1.data[0].value)
         if (res2.code == '000000') {
          this.pickData[1] = {
            values: res2.data
          };
          const res3 = await api.user.getAddressList(res2.data[0].value)
          if (res3.code == '000000') {
            this.pickData[2] = {
              values: res3.data
            };
            const res4 = await api.user.getAddressList(res3.data[0].value)
            if (res4.code == '000000') {
              this.pickData[3] = {
                values: res4.data
              };
              this.pickData = JSON.parse(JSON.stringify(this.pickData))
              console.log(this.pickData,'this.pickData')
            } else {
              JmmToast(res4.message)
            }
          } else {
            JmmToast(res3.message)
          }
        } else {
          JmmToast(res2.message)
        }
       } else {
         JmmToast(res1.message)
       }
    },

    // 回显数据
    Toshow() {
      let obj = JSON.parse(localStorage.getItem('addItem'))
      this.user = obj
      this.userId = obj.userId
      this.ischecked = obj.isDefault == 0 ? false : true
      this.$refs.city.textContent = `${obj.province} ${obj.city} ${obj.district} ${obj.town}`
      this.user.provincecode = obj.provincecode
      this.user.citycode = obj.citycode
      this.user.districtcode = obj.districtcode
      this.user.towncode = obj.towncode
      // alert(JSON.stringify(obj) + "查看回显数据")
    },
    // 点击保存
    async save() {

      let rgh = /^[1]([3-9])[0-9]{9}$/
      if (!this.addId) {  // 执行添加操作

        if (!this.user.consignee) {
          JmmToast('姓名不能为空'); return
        }
          
        if (!realnameRegular.test(this.user.consignee)) {
          JmmToast('姓名必须是汉字'); return
        }

        if (!this.user.mobile) {
          JmmToast('联系电话不能为空'); return
        }

        if (!rgh.test(this.user.mobile)) {
          return JmmToast('手机号码有误')
        }
      
        if (!this.user.province) {
          JmmToast('所在地区不能为空'); return
        }

        if (!this.user.address) {
          JmmToast('详细地址不能为空'); return
        }

        let params = {
          "address": this.user.address,     //  详细地址
          "city":  this.user.city,               //    市信息
          "citycode": this.user.citycode,              ///  市信息编号
          "town": this.user.town,               //    街道
          "towncode": this.user.towncode,            // 街道编号
          "consignee": this.user.consignee,       // 收货人名称
          "district": this.user.district,               //    区信息
          "districtcode": this.user.districtcode,            //     区编码
          "isDefault": this.ischecked ? 1 : 0,             //     是否默认 0否 1 是
          "mobile": this.user.mobile,        //     手机
          "province": this.user.province,                //  省信息
          "provincecode": this.user.provincecode,             // 省code
          "sign": this.sign,
        }
           const res = await api.user.addAddress(params);
          if (res.code == '000000') {
            let timer = new Date().getTime();
       window.location.href = this.return_url == undefined ? `h5addressList.html#/?timer=${timer}` : `h5addressList.html#/?timer=${timer}&return_url=${this.formList}`
          } else {
            JmmToast(res.message)
          }
      } else {
        // 执行修改操作
          let info = {
            "addId": this.addId,
            "userId": this.userId,
            "address": this.user.address,     //  详细地址
            "town":  this.user.town,               //    街道
            "towncode": this.user.towncode,            // 街道编号
            "city":  this.user.city,               //    市信息
            "citycode": this.user.citycode,              ///  市信息编号
            "consignee": this.user.consignee,       // 收货人名称
            "district": this.user.district,               //    区信息
            "districtcode": this.user.districtcode,            //     区编码
            "isDefault": this.ischecked ? 1 : 0,             //     是否默认 0否 1 是
            "mobile": this.user.mobile,        
            "province": this.user.province,               
            "provincecode": this.user.provincecode,            
            "sign": this.sign,
          }

         const result = await api.user.updateAddress(info);
          // alert(JSON.stringify(result) + '修改======' + JSON.stringify(info))
          if (result.code == '000000') {
            let timer = new Date().getTime();
       window.location.href = this.return_url == undefined ? `h5addressList.html#/?timer=${timer}` : `h5addressList.html#/?timer=${timer}&return_url=${this.formList}`  
            // JmmToast("修改成功")
          } else {
            JmmToast(result.message)
          }
      }
    
    },
    async onChange(picker, val,i) {
      if(i == 0){
        const res2 = await api.user.getAddressList(val[i].value)
        if (res2.code == '000000') {
          picker.setColumnValues(1, res2.data);
          const res3 = await api.user.getAddressList(res2.data[0].value)
          if (res3.code == '000000') {
            picker.setColumnValues(2, res3.data);
            const res4 = await api.user.getAddressList(res3.data[0].value)
            if (res4.code == '000000') {
              picker.setColumnValues(3, res4.data);
            } else {
              JmmToast(res4.message)
            }
          } else {
            JmmToast(res3.message)
          }
        } else {
          JmmToast(res2.message)
        }
      }else if(i == 1){
        const res3 = await api.user.getAddressList(val[i].value)
        if (res3.code == '000000') {
          picker.setColumnValues(2, res3.data);
          const res4 = await api.user.getAddressList(res3.data[0].value)
          if (res4.code == '000000') {
            picker.setColumnValues(3, res4.data);
          } else {
            JmmToast(res4.message)
          }
        } else {
          JmmToast(res3.message)
        }
      }else if(i == 2){
        const res4 = await api.user.getAddressList(val[i].value)
        if (res4.code == '000000') {
          picker.setColumnValues(3, res4.data);
        } else {
          JmmToast(res4.message)
        }
      }
    },
    cancel() {
      console.log("cancel");
    },
    onConfirm(res) {
      let obj = JSON.parse(JSON.stringify(res));
      this.user.province = obj[0].label
      this.user.provincecode = obj[0].value
      this.user.city = obj[1].label
      this.user.citycode = obj[1].value
      this.user.district = obj[2].label
      this.user.districtcode = obj[2].value

      this.user.town = obj[3].label
      this.user.towncode = obj[3].value
      let result = JSON.stringify(obj);
      //  console.log(result, '返回值')
      this.$refs.city.textContent = `${this.user.province} ${this.user.city} ${this.user.district} ${this.user.town}`;
      this.pickerVisible = false;
    },
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl';
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';


.wrapAdd1 {
  width: 100%;
  height: 100%;
  background: #fff;
}
.loginAdd {
  background: none !important;
  overflow-x: hidden;
}


.moren_address {
   width: calc(100% - 150px);
   margin: 20px auto;
   font-size: 28px;
     input {
      // border: 1px solid #fff;
      -webkit-box-shadow: none;
    }
}

.telDivAdd {
  width: calc(100% - 150px);
  margin: 15px auto;
  height: 80px;
  border-bottom: 1px solid #ddd;
  display: flex;
}

.addflex {
  align-items:center;
}

.telDivAdd_diqu, .telDivAdd_fool {
  display flex
  justify-content flex-start
  align-items center
}
.selbtn{
  width: calc(100% - 1.6rem);
  text-align: center;
  border-radius: .666667rem;
  font-size: .373333rem;
}
.telDivAdd textarea {
  border: 0;
  font-size: .373333rem;
  outline: none;
  width: calc(100% - 120px);
  height: .48rem;
  line-height: .48rem;
  display: flex;
  align-items: center;
}

.telDivAdd input {
  width: calc(100% - 120px);
  height: 66px;
  font-size: 28px;
}

.telDivAdd > span {
  display: inline-block; 
  float: left;
  align-self: center;
  width: 2.2rem !important;
  color: #000;
}

.loginBtn {
  width: calc(100% - 150px);
  height: 90px;
  line-height: 90px;
  background: $background;
  border-radius: 45px;
  font-size: 34px;
  text-align: center;
  color: $color;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  z-index: 1000;
}

.van-picker__toolbar{
  height: 88px;
}
.van-picker__toolbar button{
  font-size: 28px;
}
.van-picker-column{
  font-size: 28px;
}


</style>

<style>
 .moren_address input {
  width: .48rem;
  height: .48rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background:url('../../assets/img/images/radio_greay.png') no-repeat top center;
  background-size:.48rem .48rem;
  vertical-align: middle;
}

.moren_address input:checked{
  background:url('../../assets/img/images/radio.png') no-repeat top center;
  background-size:.48rem .48rem;
}

input[type=checkbox]:checked:before, input[type=checkbox]:before {
    display: none;
}

</style>



// WEBPACK FOOTER //
// src/view/h5address/index.vue